const FFmpegCoreLibs = async (filename) => {
  try {
    const filePath = `/ffmpeg-core/${filename}`;
    if (filename.endsWith('.js')) {
      await new Promise(() => {
        const script = document.createElement('script');
        script.src = filePath;
        script.type = 'text/javascript';
        script.async = true;
        document.body.appendChild(script);
      });
    } else if (filename.endsWith('.wasm')) {
      const wasmResponse = await fetch(filePath);
      await WebAssembly.instantiateStreaming(wasmResponse);
    } else {
      console.error('Unsupported file format:', filename);
    }
  } catch (error) {
    console.error(error);
  }
};

export default FFmpegCoreLibs;
